module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Roller-f015a5cdb12b70b86a6ccc67ab546ef8.svg";